export const EquipoComponent = (prop: {
  data: any;
  accion: any;
  loadingAccion: any;
}) => {
  return prop.data.map((e, index) => {
    return (
      <div className="card flex overflow-hidden rounded-2xl p-0" key={index}>
        <div className="h-2/2 m-0 flex  w-1/3 items-center bg-primary text-[20px] text-white">
          <p className="mx-auto tracking-wider">{e.fc_pefil_nombre}</p>
        </div>
        <div className="flex w-2/3 flex-col">
          <p className="pl-5 pt-4 text-[22px]">
            {e.nombreUsuario} {e.appUsuario} {e.apmUsuario}
          </p>
          <p className="mb-3 pl-5 font-bold">{e.username}</p>
          {e.Fails === 3 && (
            <p className="mb-4 pl-5 font-bold  text-danger">
              El usuario esta bloqueado por intentos Fallidos
            </p>
          )}
          {!prop.loadingAccion && (
            <div className="mb-4 flex pl-5">
              <div
                onClick={() => prop.accion(e.idUsuario, "er")}
                className="mr-3 cursor-pointer rounded-2xl border border-primary px-2 py-1 text-primary hover:bg-primary hover:px-3 hover:text-white"
              >
                Eliminar
              </div>
              <div
                onClick={() => prop.accion(e.idUsuario, "rc")}
                className="mr-3 cursor-pointer rounded-2xl border border-primary px-2 py-1 text-primary hover:bg-primary hover:px-3 hover:text-white"
              >
                Restablecer contraseña
              </div>
              <div
                onClick={() => prop.accion(e.idUsuario, "dr")}
                className=" cursor-pointer rounded-2xl border border-primary px-2 py-1 text-primary hover:bg-primary hover:px-3 hover:text-white"
              >
                Desbloquear
              </div>
            </div>
          )}
        </div>
      </div>
    );
  });
};
